<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="6">
        <v-autocomplete
          v-model="projectSelected"
          :items="reportTypes"
          item-text="name"
          item-value="id"
          label="Selecione o tipo de relatório"
          outlined
          dense
          hide-details
          :loading="ready"
          :disabled="ready"
          clearable
          @click:clear="clearStructure"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="projectSelected > 0" justify="center" align="center">
      <v-col cols="6">
        <ExtractData :report-type-id="projectSelected" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { LOAD_REPORT_TYPE } from '../../../vuex/modules/reportType'
import DashboardServices from '../../../services/api/extractData'
import ExtractData from './ExtractData.vue'

export default {
  name: 'ChartConfigurator',
  components: {
    ExtractData,
  },
  data() {
    return {
      apiData: [],
      projectSelected: 0,
    }
  },
  computed: {
    ...mapState('reportType', ['reportTypes', 'ready']),
  },
  created() {
    this.LOAD_REPORT_TYPE()
  },
  methods: {
    ...mapActions('reportType', [LOAD_REPORT_TYPE]),

    clearStructure() {
      this.projectSelected = 0
    },

    getFieldList() {
      return DashboardServices.fieldList(this.projectSelected)
    },
  },
}
</script>
